"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderChildrenInPortal = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var RenderChildrenInPortal = /** @class */ (function (_super) {
    tslib_1.__extends(RenderChildrenInPortal, _super);
    function RenderChildrenInPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.portalContentWrapperEl = document.createElement("div");
        return _this;
    }
    RenderChildrenInPortal.prototype.UNSAFE_componentWillMount = function () {
        if (this.props.targetElement) {
            this.props.targetElement.appendChild(this.portalContentWrapperEl);
        }
    };
    RenderChildrenInPortal.prototype.componentWillUnmount = function () {
        if (this.props.targetElement) {
            this.props.targetElement.removeChild(this.portalContentWrapperEl);
        }
    };
    RenderChildrenInPortal.prototype.render = function () {
        return react_dom_1.default.createPortal(this.props.children, this.portalContentWrapperEl);
    };
    return RenderChildrenInPortal;
}(react_1.default.Component));
exports.RenderChildrenInPortal = RenderChildrenInPortal;
//# sourceMappingURL=RenderChildrenInPortal.js.map